import { createAction, props } from '@ngrx/store';

export const SubscribeBackInStock = createAction('[Klaviyo] Subscribe back in stock', props<{ email: string; productId: string }>());
export const SubscribeBackInStockSuccess = createAction(
  '[Klaviyo] Subscribe back in stock Success',
  props<{ email: string; productId: string }>()
);
export const SubscribeBackInStockFail = createAction('[Klaviyo] Subscribe back in stock Fail', props<{ error: string }>());

export const LoadKlaviyoSubscribedProductIds = createAction('[Klaviyo] Get Klaviyo Subscribed Product Ids');
export const LoadKlaviyoSubscribedProductIdsSuccess = createAction(
  '[Klaviyo] Get Klaviyo Subscribed Product Ids Success',
  props<{ email: string; productIds: string[] }>()
);
export const LoadKlaviyoSubscribedProductIdsFail = createAction(
  '[Klaviyo] Get Klaviyo Subscribed Product Ids Fail',
  props<{ error: string }>()
);

export const ResetKlaviyoState = createAction('[Klaviyo] Reset state');
